import React, {Component} from 'react'
import './index.scss'
import {Button, message, Modal} from "antd";
import CInput from "./CInput";
import CRadio from "./CRadio";
import CTable from '@/components/CTable'

class CTables extends Component{
    constructor(props) {
        super(props);
        this.clickHandler = this.clickHandler.bind(this);
        this.modalCancel = this.modalCancel.bind(this)
        this.modalOk = this.modalOk.bind(this)
        this.onChange = this.onChange.bind(this)
        this.deletedata = this.deletedata.bind(this)
    }


    state = {
        visible: false,
        add:{
            id:'',
            name:'',
            unit:'',
            sex:'男',
            academic:'',
            title:'',
            work:'',
            age:''
        },
        options:[
            {value:'男',name:'男'},
            {value:'女',name:'女'},
        ],
        tHead: [
            {
                key: 'name',
                dataIndex: 'name',
                title: '姓名',
                width:'100px'
            },
            {
                key: 'sex',
                dataIndex: 'sex',
                title: '性别',
                width:'50px'
            },
            {
                key: 'age',
                dataIndex: 'age',
                title: '年龄',
                width:'50px'
            },
            {
                key: 'academic',
                dataIndex: 'academic',
                title: '学历',
                width:'100px'
            },
            {
                key: 'title',
                dataIndex: 'title',
                title: '职务职称',
            },
            {
                key: 'work',
                dataIndex: 'work',
                title: '在展览项目中承担的工作',
                width:'400px'
            },
            {
                key: '',
                dataIndex: '',
                title: '操作',
                slot:'operate',
                width:'150px'
            },

        ],
        value:[]
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    }


    clickHandler(){
        const  d  = this.state.add
        d.id = new Date().getTime()
        this.setState({
            visible: true,
            add:d
        })
    }

    modalCancel(){
        const data = this.state.add
        for (let key in data) {
            data[key] = ''
        }
        this.setState({
            visible: false,
            add:data
        })
    }

    modalOk(){
        if (this.state.add.name === '') {
            message.error('请输入姓名');
            return false
        }
        const data = this.state.value
        let adddata = true
        data.forEach((item,index)=>{
            if (item.id === this.state.add.id){
                data.splice(index,1,JSON.parse(JSON.stringify(this.state.add)))
                adddata = false
            }
        })
        if (adddata) {
            data.push(JSON.parse(JSON.stringify(this.state.add)))
        }
        const add = this.state.add
        for (let key in add) {
            add[key] = ''
        }
        this.setState({
            value: data,
            visible: false,
            add:add
        });
        this.props.onChange && this.props.onChange(data);
    }

    onChange(name,value){
        this.setState({
            add: {...this.state.add, [name]: value},
        })
    }

    deletedata(index){
        const data = this.state.value
        data.splice(index,1)
        this.setState({
            value: data,
        });
        this.props.onChange && this.props.onChange(data);
    }

    editData(data){
        this.setState({
            add: data,
        },()=>{
            this.setState({
                visible: true
            })
        });
    }

    componentWillMount(){
        let value = this.props.value || '';
        this.setState({
            value: value
        },()=>{
            this.forceUpdate();
        })
    }

    render(){
        return (
            <div>
                <Button onClick={ this.clickHandler }>
                    增加工作人员
                </Button>
                <CTable ref='tables' checked={false} columns={this.state.tHead} dataSource={this.state.value}>
                    <div
                        slot='operate'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <Button onClick={()=>{this.deletedata(index)}}>
                                    删除
                                </Button>
                                <Button onClick={()=>{this.editData(record)}}>
                                    编辑
                                </Button>
                            </div>
                        )} />
                </CTable>
                <Modal
                    title='增加工作人员'
                    visible={this.state.visible}
                    onOk={this.modalOk}
                    onCancel={this.modalCancel}
                    closable={true}
                    width={400}
                >
                    <div>
                        <div>
                            <div style={{margin: '10px 0', fontWeight: 'bold'}}>
                                <span style={{color:'red'}}>*</span>
                                姓名
                            </div>
                            <CInput type='input' value={this.state.add.name} onChange={(e)=>{this.onChange('name',e)}}/>
                        </div>
                        <div>
                            <div style={{margin:'10px 0',fontWeight:'bold'}}>性别</div>
                            <CRadio value={this.state.add.sex} options={this.state.options} onChange={(e)=>{this.onChange('sex',e)}} />
                        </div>
                        <div>
                            <div style={{margin:'10px 0',fontWeight:'bold'}}>年龄</div>
                            <CInput type='input' value={this.state.add.age} onChange={(e)=>{this.onChange('age',e)}} />
                        </div>
                        <div>
                            <div style={{margin:'10px 0',fontWeight:'bold'}}>学历</div>
                            <CInput type='input' value={this.state.add.academic} onChange={(e)=>{this.onChange('academic',e)}} />
                        </div>
                        <div>
                            <div style={{margin:'10px 0',fontWeight:'bold'}}>职务、职称</div>
                            <CInput type='input' value={this.state.add.title}   onChange={(e)=>{this.onChange('title',e)}} />
                        </div>
                        <div>
                            <div style={{margin:'10px 0',fontWeight:'bold'}}>在展览项目中承担的工作</div>
                            <CInput type='input' value={this.state.add.work}   onChange={(e)=>{this.onChange('work',e)}} />
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default CTables
